import { render, staticRenderFns } from "./ReceiptManage.vue?vue&type=template&id=5995378a&scoped=true"
import script from "./ReceiptManage.vue?vue&type=script&lang=js"
export * from "./ReceiptManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995378a",
  null
  
)

export default component.exports